import React from 'react'
import { useNavigate } from 'react-router-dom'
import { Button } from '../../components/button'
import { PageHeader } from '../../components/typography/PageHeader'
import Layout from '../../layout'
import EssentialsTable from './essentialsTable'

export const EssentialsPage: React.FC = () => {
  const navigate = useNavigate()

  return (
    <Layout>
      <div className="flex flex-col gap-6">
        <div className="flex justify-between gap-4 items-center">
          <PageHeader title="Essentials" className="!mb-0" />

          <Button
            type="button"
            primary
            size="medium"
            onClick={() => {
              navigate('/lists/curated/new')
            }}
            label="Add Essential"
          />
        </div>

        <EssentialsTable />
      </div>
    </Layout>
  )
}
